/**
 * Compatibility layer for pixi-heaven migration to PixiJS v8
 * pixi-heaven non è compatibile con v8, usiamo componenti standard
 */
import * as PIXI from 'pixi.js'

// SpriteH -> Sprite standard
export const SpriteH = PIXI.Sprite
export type SpriteH = PIXI.Sprite

// BitmapTextH -> BitmapText standard  
export const BitmapTextH = PIXI.BitmapText
export type BitmapTextH = PIXI.BitmapText

// MeshH -> Mesh standard
export const MeshH = PIXI.Mesh
export type MeshH = PIXI.Mesh

// ColorTransform non più necessario in v8 - usa tint e alpha
export class ColorTransform {
    public r: number = 1
    public g: number = 1
    public b: number = 1
    public a: number = 1
}

// DoubleTintMeshMaterial -> MeshMaterial standard
export const DoubleTintMeshMaterial = PIXI.MeshMaterial
export type DoubleTintMeshMaterial = PIXI.MeshMaterial

// Settings non più necessari
export const settings = {
    BLEND_WHITE: false,
}

// CLAMP_OPTIONS -> TextureStyle standard con le nuove costanti v8
export const CLAMP_OPTIONS = {
    wrapMode: 'clamp-to-edge' as const,
    scaleMode: 'linear' as const,
}

// applySpineMixin non più necessario in spine v8
export function applySpineMixin() {
    // No-op per compatibilità
}
